(function () {
  'use strict';
  if (window.__MYX_FAST_START__) return;
  var copyNode = document.getElementById('myx-fast-start-copy');
  if (!copyNode) return;
  var copy;
  try { copy = JSON.parse(copyNode.textContent); } catch (error) { return; }
  var centerId = 'rGBsXKwwThNiSwykhXb9lpED';
  var uploadId = 'Qxp4cCZHBPSyjx8HBigw9Z0c';
  var queued = false;
  var root;
  var centerInputIntent;
  var fontOrders = new WeakMap();
  var mobile = window.matchMedia('(max-width:767px)');

  function refreshRotationGuidance() {
    var title = root.querySelector('.cpb-product-title');
    if (!title) return;
    var guidance = root.querySelector('.myx-preview-rotation-guidance');
    if (!guidance) {
      guidance = document.createElement('p');
      guidance.className = 'myx-preview-rotation-guidance';
      guidance.textContent = 'Drag or swipe the 3D preview to rotate.';
    }
    if (title.nextElementSibling !== guidance) title.insertAdjacentElement('afterend', guidance);
  }

  function arrangeFontRows() {
    root.querySelectorAll('.myx-font-preview-grid').forEach(function (grid) {
      var original = fontOrders.get(grid);
      if (!original) {
        original = Array.from(grid.querySelectorAll(':scope > .myx-font-preview-card'));
        fontOrders.set(grid, original);
      }
      var ordered = original.filter(function (card) { return card.parentElement === grid; });
      var openSans = ordered.findIndex(function (card) { return card.dataset.myxFontName === 'Open Sans'; });
      if (mobile.matches && openSans > 1) ordered.splice(1, 0, ordered.splice(openSans, 1)[0]);
      ordered.forEach(function (card, index) {
        if (grid.children[index] !== card) grid.insertBefore(card, grid.children[index] || null);
      });
    });
  }

  function trackCenterInputIntent(event) {
    if (!event.isTrusted || !mobile.matches) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    centerInputIntent = null;
    var target = event.target instanceof Element && event.target;
    if (!target || target.closest('.cpb-example-button')) return;
    var choice = target.closest('[data-myx-choice-group="center"]');
    if (!choice || choice.getAttribute('aria-pressed') === 'true') return;
    var mode = choice.getAttribute('data-myx-choice-label');
    if (mode === 'Text' || mode === 'Upload Logo') {
      centerInputIntent = { mode: mode, expires: Date.now() + 2000 };
    }
  }

  function revealCenterInput(mode, input, center) {
    var intent = centerInputIntent;
    if (!intent) return;
    if (!mobile.matches || Date.now() > intent.expires) {
      centerInputIntent = null;
      return;
    }
    if (intent.mode !== mode || !input || !input.getBoundingClientRect().height) return;
    var navigation = document.querySelector('button[data-myx-customizer-step="center"]');
    if (!navigation) return;
    centerInputIntent = null;
    requestAnimationFrame(function () {
      var selected = center.querySelector('.cpb-option[aria-pressed="true"]');
      if (!mobile.matches || !input.isConnected || !selected || selected.getAttribute('data-myx-choice-label') !== intent.mode) return;
      var preview = root.querySelector('.cpb-preview-container');
      var previewBottom = preview ? preview.getBoundingClientRect().bottom : 0;
      if (input.getBoundingClientRect().top < previewBottom + 8) navigation.click();
    });
  }

  function mark(element) {
    if (!element) return;
    if (!element.classList.contains('myx-recommended-choice')) element.classList.add('myx-recommended-choice');
    if (element.querySelector(':scope > .myx-recommendation')) return;
    var color = element.matches('.cpb-option-type-color, .myx-extension-color');
    var star = document.createElement('span');
    star.className = 'myx-recommendation';
    star.setAttribute('role', 'img');
    star.setAttribute('aria-label', copy.recommended);
    star.title = copy.recommended;
    star.textContent = color ? copy.recommended : '★ ' + copy.recommended;
    element.appendChild(star);
  }

  function refresh() {
    queued = false;
    if (!root || !root.isConnected) return;
    root.classList.add('myx-fast-start');
    refreshRotationGuidance();
    var shareCard = root.querySelector('.myx-customizer-support__share');
    var previewTrigger = root.querySelector('.myx-room-preview-cta[data-myx-room-runtime="ready"]');
    if (shareCard && previewTrigger && !shareCard.parentElement.querySelector('.myx-customizer-support__preview')) {
      var previewButton = document.createElement('button');
      previewButton.type = 'button';
      previewButton.className = 'myx-customizer-support__preview';
      // Reuse the room preview's delegated handler, current design and focus return.
      previewButton.setAttribute('data-myx-room-preview-cta', '');
      previewButton.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5" stroke-linecap="round" stroke-linejoin="round"/><rect x="7" y="7" width="10" height="10" rx="1.5"/></svg><span><strong></strong><small></small></span><span aria-hidden="true">↗</span>';
      previewButton.querySelector('strong').textContent = copy.preview;
      previewButton.querySelector('small').textContent = copy.previewDetail;
      shareCard.parentElement.insertBefore(previewButton, shareCard);
    }
    var center = root.querySelector('[data-category-id="' + centerId + '"]');
    if (!center) return;
    var panel = center.closest('.cpb-panel-wrapper');
    if (panel) panel.classList.add('myx-start-panel');
    var categories = center.parentElement;
    categories.classList.add('myx-start-categories');
    var upload = categories.querySelector('[data-category-id="' + uploadId + '"]');
    var uploadLabel = upload && upload.querySelector('.cpb-drop-zone:not(.cpb-value) .cpb-upload-title > span');
    if (uploadLabel) {
      if (!uploadLabel.dataset.myxDesktopLabel) uploadLabel.dataset.myxDesktopLabel = uploadLabel.textContent;
      var uploadLabelText = mobile.matches ? copy.uploadAction : uploadLabel.dataset.myxDesktopLabel;
      if (uploadLabelText && uploadLabel.textContent !== uploadLabelText) uploadLabel.textContent = uploadLabelText;
    }
    var text = categories.querySelector('[data-category-id="SbHxRxgdGKf6gJA_Tm97efer"]');
    var selected = center.querySelector('.cpb-option[aria-pressed="true"]');
    var mode = selected && selected.getAttribute('data-myx-choice-label');
    var uploadFirst = mode === 'Upload Logo' && !!upload;
    var textFirst = mode === 'Text' && !!text;
    var heading = panel && panel.querySelector('.cpb-panel-title');
    if (heading) {
      var label = uploadFirst ? copy.upload : textFirst ? copy.text : copy.center;
      if (heading.dataset.myxStartHeading !== label) heading.dataset.myxStartHeading = label;
      if (heading.getAttribute('aria-label') !== label) heading.setAttribute('aria-label', label);
    }
    center.classList.toggle('myx-center-alternatives', uploadFirst || textFirst);
    if (center.dataset.myxAlternatives !== copy.alternatives) center.dataset.myxAlternatives = copy.alternatives;
    if (upload) upload.classList.toggle('myx-primary-input', uploadFirst);
    if (text) text.classList.toggle('myx-primary-input', textFirst);
    mark(center.querySelector('[data-myx-choice-label="Upload Logo"]'));
    mark(root.querySelector('[data-myx-choice-group="side"][data-myx-choice-label="Text Lighting"]'));
    mark(root.querySelector('[data-myx-choice-group="rgb"][data-myx-choice-label="Standard"]'));
    mark(root.querySelector('.myx-minimal-color-rail [data-myx-option-caption="Black"] .cpb-option'));
    root.querySelectorAll('.cpb-category-color [data-myx-option-caption="Warm White"] .cpb-option, .myx-extension-star-color [data-myx-option-caption="Warm White"], .myx-font-preview-card[data-myx-font-name="Open Sans"]').forEach(mark);
    mark(root.querySelector('[data-myx-bar-pattern="straight"]'));
    root.querySelectorAll('.cpb-option:is([data-option-id="DO710PxCSzV-pXaoCQDU4IqC"], [data-option-id="SFJfI4CxKMhRmer5X2orlDK3"], [data-option-id="DY2i27N9Go0mXkjzvcBCoTM5"], [data-option-id="fmDXuItx8oaqAzDNk-FasUDo"])').forEach(mark);
    arrangeFontRows();
    revealCenterInput(mode, textFirst ? text : uploadFirst ? upload : null, center);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  }

  function start() {
    root = document.getElementById('product-builder');
    if (!root) return;
    window.__MYX_FAST_START__ = { version: '1.0.0' };
    var observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-myx-choice-label', 'data-myx-choice-group'] });
    root.addEventListener('click', trackCenterInputIntent, true);
    root.addEventListener('keydown', trackCenterInputIntent, true);
    root.addEventListener('click', schedule);
    mobile.addEventListener('change', schedule);
    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', schedule);
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();
